import Snack from './Snack'

export default Snack
